<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emSppStorageInfoStiResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"  ref="emTable"
                                      exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      :header-btn-add-disabled="true"
                                      :header-btn-del-disabled="true"
                                      custom-row-actions-text="移库操作"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">




                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author thq
    // Date 2021-06-21 10:50:23

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonGotoMixin from "@/mixin/em/common/goto";


    export default {
        name: "emSppStorageInfoStiMove",
        mixins: [emCommonListMixin,emCommonGotoMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        methods:{
          gotoEdit(row) {
            this.$_emGotoMixin_gotoHolderList(
                "emSppStorageInfoSti",
                {swdIdSpwFilter: row.id},
                {swdIdSpw: row.id},
                false,
                {mainId:row.id}
            )
            let urlParam  = row.id


              this.$router.push({
                name: "emSppStorageInfoStiEdit",
                query: Object.assign({pathType: "fromParent", inline: "1"}, urlParam)
              });

          },

        },
        computed:{
            modelName(){

                //console.log(this.$_emRouterHelperMixin_entityName.slice(0,-4))
                return this.$_emRouterHelperMixin_entityName.slice(0,-4)   //特殊处理，去掉"Move"截取出entity
            }
        },
        created() {
          this.$_emCommonListMixin_needToRefresh = false;
        }
    };
</script>